export default "__VITE_ASSET__$2t$vA3B__"